import * as React from 'react';

import { Button } from '../../../../../common/components/button';

export interface IDownloadExcelButtonProps {
  onClick(): void;
}

export const DownloadExcelButton: React.VFC<IDownloadExcelButtonProps> = ({ onClick }) => {
  return (
    <Button theme="primary" mode="light" onClick={onClick} data-name="download_excel_opener">
      Сохранить файл в Excel
    </Button>
  );
};
